import React, { useEffect, useRef } from 'react';
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import * as d3 from 'd3';

const transformer = new Transformer();

const convertToMarkdown = (content) => {
  content = content.replace(/```markmap\n([\s\S]*?)```/, '$1');
  if (content.includes('#')) return content;

  const lines = content.split('\n');
  let markdown = '';

  lines.forEach(line => {
    if (!line.trim()) return;
    const indent = line.match(/^\s*/)[0].length;
    const level = Math.floor(indent / 4);
    let text = line.trim()
      .replace(/root\(\((.*?)\)\)/, '$1')
      .replace(/\(\((.*?)\)\)/, '$1')
      .replace(/\((.*?)\)/, '$1');
    const heading = '#'.repeat(level + 1);
    markdown += `${heading} ${text}\n`;
  });

  return markdown;
};

const MarkmapPopup = ({ markmapContent, onClose }) => {
  const svgRef = useRef();
  const markmapRef = useRef();
  const zoomRef = useRef();

  const createMarkmap = (content) => {
    if (!content || !svgRef.current) return;

    try {
      svgRef.current.innerHTML = '';
      markmapRef.current = null;

      const markdownContent = convertToMarkdown(content);
      const { root } = transformer.transform(markdownContent);

      if (!root || !root.children?.length) {
        throw new Error('No valid data found in markmap content.');
      }

      const mm = Markmap.create(svgRef.current, {
        initialExpandLevel: 0,
        autoFit: true
      }, root);
      

      markmapRef.current = mm;
    } catch (err) {
      svgRef.current.innerHTML = '';
      markmapRef.current = null;
      zoomRef.current = null;
    }
  };

  useEffect(() => {
    if (markmapContent) {
      createMarkmap(markmapContent);
    }

    return () => {
      try {
        // d3.select(svgRef.current).on('.zoom', null);
        if (svgRef.current) { 
          svgRef.current.innerHTML = '';
          markmapRef.current = null;
          // zoomRef.current = null;
        }
      } catch (err) {
        console.error('Cleanup failed:', err);
      }
    };
  }, [markmapContent]);

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 1000
      }}
    >
      <div
        className="modal-content-markmap modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '90vw', height: '80vh',
          backgroundColor: '#fff', padding: '20px',
          borderRadius: '8px', position: 'relative',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <button
          className="close-btn"
          onClick={onClose}
          style={{
            position: 'absolute', top: '10px', right: '10px',
            fontSize: '24px', background: 'none', border: 'none',
            cursor: 'pointer', color: '#666'
          }}
        >×</button>
        <svg ref={svgRef} height={"800px"} width={"800px"}  style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  );
};

export default MarkmapPopup;
